export type AssistantInvocationContext = {
  area?: string;
  source?: "command" | "attention" | "contextual" | "assistant";
  recordIDs?: string[];
};

export type AssistantInvocation = {
  prompt?: string;
  autoSubmit?: boolean;
  context?: AssistantInvocationContext;
};

export type AssistantSkill = {
  id: string;
  name: string;
  prompt: string;
};

const ASSISTANT_OPEN_EVENT = "listwork:assistant:open";
const ASSISTANT_SKILLS_VERSION = 1;

export function openAssistant(invocation: AssistantInvocation = {}) {
  window.dispatchEvent(new CustomEvent<AssistantInvocation>(ASSISTANT_OPEN_EVENT, { detail: invocation }));
}

export function subscribeToAssistantOpen(listener: (invocation: AssistantInvocation) => void) {
  const handler = (event: Event) => listener((event as CustomEvent<AssistantInvocation>).detail ?? {});
  window.addEventListener(ASSISTANT_OPEN_EVENT, handler);
  return () => window.removeEventListener(ASSISTANT_OPEN_EVENT, handler);
}

export function loadAssistantSkills(workspaceID?: string): AssistantSkill[] {
  if (!workspaceID) return [];
  try {
    const value = JSON.parse(localStorage.getItem(skillsKey(workspaceID)) ?? "null") as { version?: number; skills?: AssistantSkill[] } | null;
    if (value?.version !== ASSISTANT_SKILLS_VERSION || !Array.isArray(value.skills)) return [];
    return value.skills.filter((skill) => skill && typeof skill.id === "string" && typeof skill.name === "string" && typeof skill.prompt === "string").slice(0, 25);
  } catch {
    return [];
  }
}

export function saveAssistantSkills(workspaceID: string, skills: AssistantSkill[]) {
  localStorage.setItem(skillsKey(workspaceID), JSON.stringify({
    version: ASSISTANT_SKILLS_VERSION,
    skills: skills.slice(0, 25)
  }));
}

function skillsKey(workspaceID: string) {
  return `listwork:assistant:skills:${workspaceID}`;
}
